import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import CustomLangCookies from 'i18n/customLanguageCookies';

import translationKO from 'i18n/languages/messages_ko_KR.json';
import translationEN from 'i18n/languages/messages_en_US.json';
import translationZH from 'i18n/languages/messages_zh_CN.json';
import translationTW from 'i18n/languages/messages_zh_TW.json';
import translationJP from 'i18n/languages/messages_ja_JP.json';
import translationVI from 'i18n/languages/messages_vi_VN.json';
import translationFR from 'i18n/languages/messages_fr_FR.json';

const languageDetector = new LanguageDetector();
languageDetector.addDetector(CustomLangCookies);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['customLangCookies', 'navigator'],

      lookupCustomLangCookies: 'saveLanguage',
    },
    resources: {
      ko: {
        translation: translationKO,
      },
      en: {
        translation: translationEN,
      },
      zh: {
        translation: translationZH,
      },
      ja: {
        translation: translationJP,
      },
      tw: {
        translation: translationTW,
      },
      vi: {
        translation: translationVI,
      },
      fr: {
        translation: translationFR,
      },
    },
    fallbackLng: ['en'],
    interpolation: {
      escapeValue: false,
      skipOnVariables: false,
    },
    returnNull: true,
  });

export default i18n;
